import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import { WithHotelErrorBoundary } from '../WithHotelErrorBoundary';
import { HotelManagerMobileWithHotelStandalone } from './HotelManagerMobileWithHotelStandalone';
import { WithHotelEntryPoint } from '../WithHotelEntryPoint';
import { setChainFilter } from '../../../redux/currentSearch/actions';

const HotelMobile = ({ rootDataAttr }) => {
    const dispatch = useDispatch();

    useEffect(() => {
        if (rootDataAttr.chainFilter) {
            dispatch(setChainFilter(rootDataAttr.chainFilter));
        }
    }, [dispatch, rootDataAttr.chainFilter]);

    return <HotelManagerMobileWithHotelStandalone />;
};

HotelMobile.propTypes = {
    rootDataAttr: PropTypes.object,
};

export const HotelManagerMobile = WithHotelEntryPoint(WithHotelErrorBoundary(HotelMobile));
